module.exports = __webpack_public_path__ + "static/img/7.e5cfefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/7.png
// module id = FrUE
// module chunks = 0